import AppDatePicker from '@nxsys/components/AppDatePicker';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import { Moment } from 'moment';
import React, { useEffect, useState } from 'react';
import AppCurrencyInput from '@nxsys/components/AppCurrencyInput';

type SubmitExpenseModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onSubmit: (params: SubmitExpenseValues) => Promise<void>;
  defaultValues?: Partial<SubmitExpenseValues>;
};

export type SubmitExpenseValues = {
  openingBalance: string;
  date: Moment | null;
};

const SubmitExpenseModal: React.FC<SubmitExpenseModalProps> = ({
  isOpen,
  toggle,
  onSubmit,
  defaultValues = {},
}: SubmitExpenseModalProps) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm();
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isOpen) {
      form.setFieldsValue(defaultValues);
    }
  }, [isOpen]);

  const onFinish: FormProps['onFinish'] = async (values) => {
    try {
      setIsSubmitting(true);
      await onSubmit(values);
      form.resetFields();
    } catch (err) {
      console.error(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages['common.submitExpense']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.save'],
          buttonType: 'primary',
          onClick: () => form.submit(),
          loading: isSubmitting,
          disabled: isSubmitting,
        },
      ]}
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          label={messages['common.date']}
          name="date"
          rules={[{ required: true, message: messages['form.pleaseSelect'] }]}
        >
          <AppDatePicker
            placeholder={messages['form.selectDate']}
            format="DD/MM/YYYY"
          />
        </Form.Item>
        <Form.Item
          label={messages['common.openingBalance']}
          name="openingBalance"
          rules={[{ required: true, message: messages['form.pleaseEnter'] }]}
        >
          <AppCurrencyInput placeholder={messages['form.enterAmount']} />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default SubmitExpenseModal;
